<template lang="html">
  <div>

    <div class="vx-card nexteventheader_div">
      <div class="vx-card__header">
        <div class="vx-card__title">
          <p class="">{{$t('QuorumTypes')}}
            <feather-icon 
              icon="DownloadCloudIcon" 
              svgClasses="w-5 h-5 hover:text-danger stroke-current" 
              class="ml-5" 
              :title="$t('ExportList')"
              @click="activePrompt=true"
            />
          </p>
        </div>
      </div>
    </div>

    <vs-prompt :title="$t('ExportToExcel')" class="export-options" @cancle="clearFields" @accept="exportToExcel" accept-text="Export" @close="clearFields" :active.sync="activePrompt">
      <vs-input v-model="fileName" :placeholder="$t('EnterFileName') + '..'" class="w-full" />
      <v-select v-model="selectedFormat" :options="formats" class="my-4" />
      <div class="flex">
        <span class="mr-4">{{$t('CellAutoWidth')}}:</span>
        <vs-switch v-model="cellAutoWidth">{{$t('CellAutoWidth')}}</vs-switch>
      </div>
    </vs-prompt>
    
    <vs-table max-items="10" pagination :data="events">
      
      <template slot="thead">
        <vs-th>{{$t('Quorum')}}</vs-th>
        <vs-th>{{$t('Formula')}}</vs-th>
      </template>

      <template slot-scope="{data}">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].quorum_type">{{ $t(data[indextr].quorum_type) }} </vs-td>
            <vs-td :data="data[indextr].quorum_formula">{{ data[indextr].quorum_formula }} </vs-td>
          </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
import vSelect from 'vue-select'
export default {
  components: {
    vSelect
  },
  data: () => ({
    activePrompt: false,
    fileName: '',
    // formats:['xlsx', 'csv', 'txt'],
    formats:['xlsx'],
    cellAutoWidth: true,
    selectedFormat: 'xlsx',
    headerTitle: ['Quorum', 'Formula'],
    headerVal: ['quorum_type', 'quorum_formula'],
    events: [{}],
    url: "/admin/event/getQuorums/",
  }),
  mounted() {
    this.getQuorums();
  },
  methods: {
    getQuorums() {
      this.$vs.loading();
      this.$store
        .dispatch("getQuorums")
        .then(response => {
          this.$vs.loading.close();
          this.events = response.data.data;
        })
        .catch(error => {
          this.$log.error('File : QuorumListing.vue | Function : getQuorums() | Error :', error);
          this.$vs.loading.close();
          // Error response
          this.$vs.notify({
            title: "Failed to load data",
            text: error,
            color: "danger",
            position: "top-center"
          });
          return false;
        });
    },
    exportToExcel () {
      import('@/utils/Export2Excel').then(excel => {
        const list = this.events
        const data = this.formatJson(this.headerVal, list);
      
        excel.export_json_to_excel({
          header: this.headerTitle.map(t => this.$t(t)),
          data,
          filename: this.fileName,
          autoWidth: this.cellAutoWidth,
          bookType: this.selectedFormat
        })
        this.clearFields()
      })
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        return v[j]
      }))
    },
    clearFields () {
      this.filename = ''
      this.cellAutoWidth = true
      this.selectedFormat = 'xlsx'
    }
  }
};
</script>

<style lang="scss">
.nexteventheader_div {
  border-radius: 0 !important;
}
.vx-card__title p{
  font-weight: 600 !important;
  font-size: 1.0rem !important;
  padding-bottom: 10px;
}
.vx-card__header{
  padding: 1.2rem 1.2rem 0 !important;
}
.run_btn{
  padding: 0.5rem 1.1rem !important;
  font-size: 12px;
}
.testing{
  text-align: center;
}
.testing .vs-table-text{
  display: unset;
}
.testertd {
  width: 10%;
  text-align: center;
}
.run_btn_action{
  width: 13%;
}
.actioniconmanage{
  margin-top: 1px;
}
</style>